import {
  AuditionRequestIcon,
  Backdrop,
  ClockCircleIcon,
  LoadingSpinnerIconTwoTone,
  NotificationsAlertWhiteIcon,
  SelfTapesIcon,
  Typography,
} from '@room-match/shared-ui-components';
import React, { useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { ICompanyAddressAttributes } from 'shared/interfaces/ICompany';
import { readableProjectUnion } from 'shared/utils/room-shared';

import { IconCont } from 'pages/AuditionRequest/AuditionRequestItem/AuditionRequestItem.styles';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';
import { STTimeDateParser, timeConvert } from 'shared/utils/timeHelpers';
import { CardContainer, CardHeader, EmptyContainer } from '../Dashboard.styles';
import { FlexRightContainer, ItemContainer, Left, ListContainer, Middle, Right } from './AuditionRequests.styles';
import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
const { WARNING_ICON, PRIMARY_ICON } = COLORS;

type Props = {
  count: number;
};

const { getAuditionRequest } = auditionScheduleService();

const AuditionRequests: React.FC<Props> = ({ count = 0 }) => {
  //this is for attended audition changed dashboard layout (17/05/23')
  // const { data, isLoading } = getAuditionSchedules({
  //   phase: AuditionPhase.SUBMISSION,
  //   status: AuditionStatus.AUDITIONED,
  //   first: 2,
  //   after: '',
  // });

  const { data, isLoading } = getAuditionRequest({
    // status: AuditionStatus.DECLINED,
    // phase: 'Submission',
    first: 2,
  });

  const history = useHistory();

  const getData = useMemo(() => {
    return data
      ? data.pages.filter((v, index) => index === 0).map((i) => i.data.audition_schedule_requests_connection.nodes)
      : undefined;
  }, [data]);

  if (isLoading) return <Backdrop isLoading={true} />;
  return (
    <CardContainer>
      <CardHeader>
        <div>
          <AuditionRequestIcon />
          <span style={{ fontSize: 18 }}>Audition Requests</span>
        </div>
        <Link to={`${ROUTES.TALENT.AUDITIONS}/audition_request`}>
          <Typography color="warning" fontSize={14}>
            {count === 0 ? `` : count > 1 ? `${count} Auditions` : `${count} Audition`}
          </Typography>
        </Link>
      </CardHeader>
      <ListContainer>
        {isLoading ? (
          <LoadingSpinnerIconTwoTone />
        ) : getData && getData[0].length > 0 ? (
          getData[0].map(
            (i) =>
              i && (
                <ItemContainer onClick={() => history.push(`${ROUTES.TALENT.AUDITIONS}/audition_request/${i.id}`)}>
                  <Left>
                    {/* <Avatar
                      style={{ height: 44, width: 44, borderRadius: 5 }}
                      title={i.audition.casting_role.project.name}
                      uuid={i.audition.casting_role.project.id}
                    ></Avatar> */}
                    {i.status === 'Reschedule' ? (
                      <IconCont BG={WARNING_ICON}>
                        <ClockCircleIcon />
                      </IconCont>
                    ) : (
                      <IconCont BG={PRIMARY_ICON}>
                        <NotificationsAlertWhiteIcon />
                      </IconCont>
                    )}
                    <div>
                      <CustomTypography fontSize={12}>
                        {i.audition.casting_role.project.company.addresses
                          .filter((v: ICompanyAddressAttributes) => v.primary === true)
                          .map((i: ICompanyAddressAttributes) => `${i.location_name}, ${i.city_suburb}`) || '–'}
                      </CustomTypography>
                      <CustomTypography fontSize={16} fontWeight={500}>
                        {i.audition.casting_role.project.name || '–'}
                      </CustomTypography>
                      <CustomTypography fontSize={12}>
                        {i.audition.casting_role.project.union
                          ? readableProjectUnion(i.audition.casting_role.project.union)
                          : '–'}
                      </CustomTypography>
                    </div>
                  </Left>
                  <Middle>
                    <div>
                      <CustomTypography fontSize={14}>Rep:</CustomTypography>
                      {i.audition.profile?.agency?.name ? (
                        <CustomTypography color="primary" fontSize={14}>
                          {i.audition.profile?.agency?.name}
                        </CustomTypography>
                      ) : (
                        <CustomTypography fontSize={14}>Non Represented</CustomTypography>
                      )}
                    </div>
                    <div>
                      <CustomTypography fontSize={14}>Role:</CustomTypography>
                      <TypographyTooltip style={{ fontSize: 14, width: '100%', maxWidth: 180, textAlign: 'end' }}>
                        {i.audition.casting_role.name || ''}
                      </TypographyTooltip>
                    </div>

                    <div>
                      <CustomTypography fontSize={14}>Date & Time:</CustomTypography>
                      <CustomTypography fontSize={14}>
                        {i.phase === 'Self Tapes Request'
                          ? STTimeDateParser(
                              i.audition.casting_role.self_tapes_requirements?.date || '',
                              i.audition.casting_role.self_tapes_requirements?.time || '',
                              i.audition.casting_role.self_tapes_requirements?.timezone || '',
                            )
                          : timeConvert(i)}
                      </CustomTypography>
                    </div>
                    <div>
                      <CustomTypography fontSize={14}>Location:</CustomTypography>
                      <CustomTypography fontSize={14}>
                        {i.audition.profile.agency?.state && i.audition.profile.agency?.country
                          ? `${i.audition.profile.agency?.state}, ${i.audition.profile.agency?.country}`
                          : i.audition.profile.agency?.state
                            ? i.audition.profile.agency?.state
                            : i.audition.profile.agency?.country
                              ? i.audition.profile.agency?.country
                              : ''}
                      </CustomTypography>
                    </div>
                  </Middle>
                  <Right>
                    <FlexRightContainer>
                      {i.phase == 'Self Tapes Request' ? <SelfTapesIcon /> : <AuditionRequestIcon />}
                      <CustomTypography style={{ fontSize: 14, whiteSpace: 'nowrap' }}>
                        {i.phase == 'Self Tapes Request' ? 'Self Tape' : '  Audition'}
                      </CustomTypography>
                    </FlexRightContainer>
                  </Right>
                </ItemContainer>
              ),
          )
        ) : (
          <EmptyContainer>No data available</EmptyContainer>
        )}
      </ListContainer>
    </CardContainer>
  );
};

export default AuditionRequests;
